module.exports = __webpack_public_path__ + "static/media/cooking_basics.4c7bd1aa.svg";